export default __webpack_public_path__ + "fb047f2b355270665513915a57c34201.png";